import { PluginOptions, POSITION, TYPE } from "vue-toastification";

export const toastOptions: PluginOptions = {
  toastDefaults: {
    [TYPE.ERROR]: {
      timeout: 3000,
      closeButton: false,
      position: POSITION.BOTTOM_CENTER,
    },
    [TYPE.SUCCESS]: {
      timeout: 3000,
      hideProgressBar: true,
      position: POSITION.BOTTOM_CENTER,
    },
  },
};
